import React, { useContext, useCallback, useEffect, useState } from "react";
import moment from "moment";
import { AuthContext } from "../../../Context/AuthContext";
import { activityLogsThunk } from "../../../store/actions/activitylogs/activity.thunk";
import { useDispatch, useSelector } from "react-redux";

import { PageBody } from "../../../components/loader";
import { useLoadingMessage } from "../../../components/useLoadingMessage";

export const ActivityLog = () => {
  const { user } = useContext(AuthContext);
  const { isLoading, message, updateLoader } = useLoadingMessage();
  const [Loading, setLoading] = useState(false);
  const load = <span className="fa fa-spin fa-spinner"></span>;

  const { activityLog, next, prev, currentPage, last } = useSelector(
    (state) => state.activitylogs
  );
  const dispatch = useDispatch();

  // const getActivityLogs = useCallback(async () => {
  //   updateLoader(true, "Loading");
  //   await dispatch(activityLogsThunk.getActivityLogs());
  //   updateLoader(false);
  // }, [dispatch]);

  const handleFetchLogs = async (query) => {
    // updateLoader(true, "Loading");
    setLoading(true);
    await dispatch(activityLogsThunk.getActivityNextLogs(query));
    // updateLoader(false);

    setLoading(false);
  };

  useEffect(() => {
    let isMounted = true;
    if (isMounted) handleFetchLogs();
    return () => {
      isMounted = false;
    }; // cleanup toggles value, if unmounted
  }, []);

  const activityLogs = !Array.isArray(activityLog)
    ? Object.values(activityLog)
    : activityLog;
  let activePage = currentPage;

  return (
    // <PageBody isLoading={isLoading} message={message}>
    <div className="content">
      <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            <div className="page-title-box-two">
              <h4 className="page-title"></h4>
              <h1 className="welcome_text">ACTIVITY LOG</h1>
              <div className="clearfix"></div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-12 col-md-12 col-xs-12">
            <div className="table-wrapper table-responsive">
              <div className="table-title">
                <div className="row">
                  <div className="col-sm-6">
                    {user.data.user.roles &&
                    user.data.user.roles.name === "admin" ? (
                      <h2>ACTIVITIES BY ALL USERS</h2>
                    ) : (
                      <h2>ACTIVITIES PERFORMED BY YOU</h2>
                    )}
                  </div>
                  <div class="col-sm-6"></div>
                </div>
              </div>
              <div></div>
              <table id="" className="table table-bordered asset-table">
                <thead>
                  <tr>
                    <th>NO</th>
                    <th className="th-sm"> NAME</th>
                    <th className="th-sm">EMPLOYEE ROLE</th>
                    <th className="th-sm">ACTION</th>
                    <th className="th-sm">IP ADDRESS</th>

                    <th className="th-sm">DATE</th>
                    <th className="th-sm">TIME</th>
                  </tr>
                </thead>
                <tbody>
                  {activityLogs.map((activity, i) => (
                    <tr key={i}>
                      <td>{i + 1}</td>
                      <td>{`${activity.user.first_name} ${activity.user.last_name}`}</td>
                      <td>{activity.user.first_name}</td>
                      <td>{activity.action}</td>
                      <td>{activity.ip}</td>
                      <td>
                        {moment(activity.created_at).format("MMM, Do YY")}
                      </td>
                      {/* <td>
                        {moment(activity.created_at).fromNow()}
                      </td> */}
                      <td>{moment(activity.created_at).format("LT")}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <nav aria-label="...">
                <ul class="pagination">
                  <li class={`page-item ${prev === null ? "disabled" : ""}`}>
                    <a
                      class="page-link"
                      onClick={() => handleFetchLogs(prev)}
                      aria-disabled={
                        !activityLog.prev_page_url ? "true" : "false"
                      }
                      // aria-disabled={activityLog.prev_page_url}
                    >
                      Previous
                    </a>
                  </li>
                  {[...Array(last).keys()].map((page, i) => (
                    <li
                      class={`page-item ${
                        page + 1 === activePage ? "active" : ""
                      }`}
                      key={i}
                    >
                      <a
                        class="page-link"
                        id={page + 1}
                        onClick={() => handleFetchLogs(`?page=${page + 1}`)}
                      >
                        {page + 1}
                      </a>
                    </li>
                  ))}
                  <li class={`page-item ${next === null ? "disabled" : ""}`}>
                    <a class="page-link" onClick={() => handleFetchLogs(next)}>
                      {Loading ? load : "Next"}
                    </a>
                  </li>
                </ul>
              </nav>
              {/* <div className="text-dark h4">Current page: {currentPage}</div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
    // </PageBody>
  );
};



// WEBPACK FOOTER //
// ./src/container/dashboard/activity/index.js